import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/functions'
import 'firebase/analytics'
import 'firebase/performance'

import router from './router/'
import { store } from './store/index.js'
import './registerServiceWorker'
import AlertCmp from './components/Shared/Alert.vue'
import Vue2Filters from 'vue2-filters'
import VueTour from 'vue-tour'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import VueConfetti from 'vue-confetti'
Vue.use(VueConfetti)

Sentry.init({
  dsn: 'https://4d298205e0274a8e84988413b738af2d@sentry.io/1474196',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  environment: process.env.VUE_APP_ENVIRONMENT
})

require('vue-tour/dist/vue-tour.css')

Vue.use(Vue2Filters)
Vue.use(VueTour)
Vue.filter('toCurrency', function (value, lang = 'en', currency = 'GBP') {
  // make it a number
  const amount = parseFloat(value)
  if (isNaN(amount)) {
    return value
  }
  var formatter = new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: currency
  })
  return formatter.format(amount)
})

Vue.config.productionTip = false

Vue.component('app-alert', AlertCmp)

// create FB config object so we can patch it for local emulator testing
let firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTID,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPID,
  measurementId: process.env.VUE_APP_MEASUREMENTID
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp(firebaseConfig)
    // initialise analytics
    firebase.analytics()
    // initialise performance
    firebase.performance()
    // watch auth state change
    if (location.hostname === 'localhost') {
      // do the emulator connections if we're doing that
      firebase.auth().useEmulator('http://localhost:9099/')
      firebase.database().useEmulator('localhost', 9000)
      firebase.functions().useEmulator('localhost', 5001)
      // firebase.storage().useEmulator('localhost', 9199)
    }
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      } else {
        // this stops the loader on signin from running for ever. We use this loader to stop the f5 login flash issue
        this.$store.commit('setLoading', false)
      }
    })
  }
})
